import { normalizeNumber } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_SIGN_VALIDATION_ERROR_SAMPLE_RATE = createFcmConfig('sign_validation_error_sample_rate', {
	normalizer: normalizeNumber,
	defaultValue: 15,
});
